import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AppShell from '@/components/AppShell';
import { useEditUnit, wrapConnection } from '@/components/editUnit/useEditUnit';
import { BasicInfoCard, StandardsCard, VocabularyCard, IdentificationsCard } from '@/components/editUnit/sections';

const blankIdentification = () => ({ type: 'person', name: '', description: '', significance: '', connections: [wrapConnection('')] });

export default function EditUnit() {
  const {
    unitId, navigate, loading, saving,
    formData, setFormData,
    standards, standardOps,
    vocabulary, vocabOps,
    identifications, identOps, connectionOps,
    handleSubmit,
  } = useEditUnit();

  if (loading) {
    return (
      <AppShell>
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-[#14213D] border-t-transparent"></div>
            <p className="mt-4 text-sm text-[#5A6577]">Loading unit...</p>
          </div>
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(`/unit/${unitId}`)}
          className="mb-4 text-[#5A6577] hover:text-[#14213D]"
          data-testid="back-to-unit-btn"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Unit
        </Button>
        <div className="mb-8">
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] font-semibold mb-2">Admin</p>
          <h1 className="font-serif-display text-4xl text-[#14213D] tracking-tight mb-2">Edit Unit</h1>
          <p className="text-sm text-[#5A6577]">Update curriculum unit content and materials.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          <BasicInfoCard formData={formData} setFormData={setFormData} />
          <StandardsCard standards={standards} ops={standardOps} />
          <VocabularyCard vocabulary={vocabulary} ops={vocabOps} />
          <IdentificationsCard
            identifications={identifications}
            ops={identOps}
            connectionOps={connectionOps}
            blankIdentification={blankIdentification}
          />
          <div className="flex justify-end gap-4">
            <Button type="button" variant="outline" onClick={() => navigate(`/unit/${unitId}`)} data-testid="cancel-edit-btn">
              Cancel
            </Button>
            <Button type="submit" className="btn-primary" disabled={saving} data-testid="save-unit-btn">
              {saving ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
        </form>
      </div>
    </AppShell>
  );
}
